import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const CloseTemplateTaskBulkEstimateCommandsList: FC<
    CommandsListProps
> = ({ options = {} }) => {
    const {
        selectedCloseTemplateTaskCount = 0,
        closeTemplateTaskBulkEstimateOptions = [],
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set estimate for ${selectedCloseTemplateTaskCount} ${pluralize("task", selectedCloseTemplateTaskCount)}`}
            options={closeTemplateTaskBulkEstimateOptions}
        />
    );
};
